export default __webpack_public_path__ + "static/media/CRM.3328c4f1.svg";